import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { CgSpinner } from "react-icons/cg";
import { SEC_DataApiPost } from "../../func.js";
import "./MarkRequestComplete.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "../Tooltip";

export function MarkRequestComplete({ id, url, updateApiCallFunction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [postApiErrorState, setPostApiErrorState] = useState(false);

  async function callComplete() {
    if (isLoading) return; // Prevent multiple clicks
    setIsLoading(true);
    setPostApiErrorState(false);

    let formData = { "requestId": id };
    // let url = "it-requests/single-it-request/complete";

    try {
      const response = await SEC_DataApiPost(url, formData, formData, () => setPostApiErrorState(true));
      
      if (response && response.ResponseMetadata.HTTPStatusCode === 200) {
        toast.success("✅ Request marked as complete!", { autoClose: 3000, position: "top-right" });
        updateApiCallFunction(id);
      } else {
        toast.error("❌ Failed to mark request as complete. Please try again.", { autoClose: 3000, position: "top-right" });
      }
    } catch (e) {
      console.log(e);
      toast.error("⚠️ An error occurred while processing the request.", { autoClose: 3000, position: "top-right" });
      setPostApiErrorState(true);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Tooltip text="Request complete">
        <button onClick={callComplete} className="mark-complete-button" disabled={isLoading}>
          {isLoading ? <span className="loading-spinner"><CgSpinner className="spinner" /></span> : <FaCheck />}
        </button>
      </Tooltip>
    </>
  );
}
